var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystal2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystalGrad2a",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1f1f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0a15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystalGrad2b",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#252540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#101020"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "crystalGlow2",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00D4AA",
    floodOpacity: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#crystalGlow2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40,3 65,30 65,70 40,97 15,70 15,30",
    fill: "url(#crystalGrad2a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,3 40,97 15,70 15,30",
    fill: "url(#crystalGrad2b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,20 55,35 55,65 40,80 25,65 25,35",
    fill: "#05050c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 3,
    x2: 40,
    y2: 97,
    stroke: "#00D4AA",
    strokeWidth: 0.4,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 30,
    x2: 65,
    y2: 30,
    stroke: "#00D4AA",
    strokeWidth: 0.3,
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 70,
    x2: 65,
    y2: 70,
    stroke: "#00D4AA",
    strokeWidth: 0.3,
    strokeOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystal2);
export default __webpack_public_path__ + "static/media/crystal-2.0153af541445a1ab33055022bd0d4814.svg";
export { ForwardRef as ReactComponent };